import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../../../../../common/state';
import { changeApartment } from '../../../../../../state/advanced/dwelling_status';

import { DwellingStatus as DwellingStatusComponent } from './dwellingStatus';

export const DwellingStatus = connect(
  (state: IAppState) => ({
    withApartment: state.filters.jsonQuery.apartment
      ? state.filters.jsonQuery.apartment.value
      : state.filters.jsonQuery.only_flat && !state.filters.jsonQuery.only_flat.value,
  }),
  (dispatch: Dispatch) => ({
    onApartmentChanged: (value: boolean | undefined) => {
      dispatch(changeApartment(value));
    },
  }),
)(DwellingStatusComponent);
